export default "__VITE_ASSET__DYC_DEXG__ 480w, __VITE_ASSET__xOR0pWdB__ 768w, __VITE_ASSET__vmX$nvvz__ 1200w, __VITE_ASSET__ClUrJELn__ 1920w";